export const numberFormat = (value: number) =>
new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
}).format(value);